import axios from 'axios'

export default {
  methods: {
    uploadFileForConvert(payload) {
      return axios.post(process.env.VUE_APP_CONVERT_IMAGE_SERVER_URL + '/upload.php', payload)
    },
    checkToCovertFile(params) {
      return axios.get(process.env.VUE_APP_CONVERT_IMAGE_SERVER_URL + `/isImageVectorized.php`, {params})
    },
    getSvgQuery(params) {
      return axios.get(process.env.VUE_APP_CONVERT_IMAGE_SERVER_URL + `/returnImage.php`, {params})
    }
  }
}
